import {
  mapActions,
  mapGetters
} from 'vuex';
import ConfirmInscriptionI18n from './ConfirmInscription.i18n.js';

export default {

  components: {},

  props: {},

  computed: {
    ...mapGetters(['user'])
  },

  data() {
    return {};
  },

  watch: {},

  methods: {
    ...mapActions(['confirmRegister', 'getUser'])
  },

  mounted() {
    window.scrollTo(0, 0)
    const info = {
      uniqueCode: this.$route.params.uniqueCode
    }
    this.confirmRegister(info).then(res => {
      this.getUser().then(res => {

      }).catch(err => {
        console.log(err)
      })
    }).catch(err => {
      this.error = true
      console.log(err)
    })
  },

  i18n: ConfirmInscriptionI18n,

};